import {
    ActivitiesDetailPageDesktopContextFieldsV2,
    ActivitiesDetailPageDesktopContextIdsV2,
    ActivitiesDetailPageDesktopContextManifestV2,
} from '@agoda/analytics-messages-definition-activities/manifest/activities-detail-page-desktop';
import { PartialActivitiesWebAppDataContextFields, WebAnalyticsBinder, WebAnalyticsContextFieldsMap } from 'core/messaging/analytics/ActivitiesAppDataContext';
import { getCrossedOutRate, mapActivityForDetail, mapPricingByPricingSummary, selectDisplayPricing } from 'gql/service/graph/activityService';
import { DetailsPageContextFields } from 'core/messaging/analytics/pages/pageEventsMapping';
import { getStoreState } from 'store/store';
import { getDateInYmdFormat } from 'core-framework/util/datetime/date';

const getDetailsPageContextPropsFromState = () => {
    const { home: homeState, details: detailState, bootstrap: bootStrap } = getStoreState();
    const activity = mapActivityForDetail(detailState);
    const priceBehavior = bootStrap.config.behavior.common.price;
    const travelDate = getDateInYmdFormat(homeState?.searchBoxSettings?.travelDate);
    if (!activity) {
        return { activity, hasCor: false, travelDate };
    }
    const pricingSummary = detailState.detailsResponse?.result?.activity?.activityRepresentativeInfo?.pricingSummary;
    if (!pricingSummary) {
        return { activity, hasCor: false, travelDate };
    }

    const totalPrice = selectDisplayPricing(mapPricingByPricingSummary(pricingSummary), priceBehavior.displayType);
    const hasCor = !!getCrossedOutRate(priceBehavior.crossedOutRateBehavior, totalPrice);

    return { activity, hasCor, travelDate };
};

export const getDetailPageContextFields = (): WebAnalyticsContextFieldsMap<DetailsPageContextFields & PartialActivitiesWebAppDataContextFields> => {
    let props: ReturnType<typeof getDetailsPageContextPropsFromState>;
    return {
        // These property accessors are called in sequence by virtue of Object.keys iterating in order.
        // We can fetch the required data in the first accessors and use it in the subsequent ones.
        master_activity_id: () => {
            props = getDetailsPageContextPropsFromState();
            return props.activity?.masterActivityId;
        },
        master_supplier_id: () => {
            return props.activity?.masterSupplierId;
        },
        // Fallback for case that we don't know child activity_id
        activity_id: () => {
            return props.activity?.masterActivityId;
        },
        supplier_id: () => {
            return props.activity?.masterSupplierId;
        },
        has_crossout_rate: () => {
            return props.hasCor;
        },
        travel_date: () => {
            return props.travelDate;
        },
        activities_categories: () => {
            return props.activity.content?.activity?.categories?.join(',') || '';
        },
    };
};

export const detailPageBinder: WebAnalyticsBinder = (webAnalytics) => {
    webAnalytics.pageContext<ActivitiesDetailPageDesktopContextIdsV2, ActivitiesDetailPageDesktopContextFieldsV2>(
        ActivitiesDetailPageDesktopContextManifestV2.ids,
        getDetailPageContextFields(),
    );
};
